<template>
  <div class="app-overview-bar">
    <ul class="app-overview-bar__content">
      <slot></slot>
    </ul>
  </div>
</template>

<script>
import Item from './Item'

export const AppOverviewBarItem = Item
export default {
  name: 'AppOverviewBar'
}
</script>

<style lang="scss">
.app-overview-bar {
  &__content {
    display: flex;
    padding: 0;
    margin: 0;
    list-style: none;
  }
}
</style>
